import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import NotoSansDevanagari from "../Noto_Sans_Devanagari/static/NotoSansDevanagari/NotoSansDevanagari-Regular.ttf";
import moment from "moment";

const Form_13 = ({arrayData}) => {
  console.log(arrayData)
  Font.register({
    family: "Noto Sans Devanagari",
    src: NotoSansDevanagari,
  });
  const styles = StyleSheet.create({
      page: {
        backgroundColor: "#E4E4E4",
        fontSize: "12px",
        fontWeight: "200",
        fontFamily: "Noto Sans Devanagari",
      },
      section: {
        flexDirection: "row",
        textAlign: "center",
        flexWrap: "wrap",
        padding: "10px",
      },
      // table: {
      //   flexDirection: "row",
      //   textAlign: "center",
      //   flexWrap: "wrap",
      //   borderTop: "1px solid black",
      //   marginRight: "10px",
      //   marginRight: "10px",
      // },
      textCenter: {
        textAlign: "center",
        paddingTop: 3,
      },
      textLeft: {
        textAlign: "left",
        paddingTop: 3,
      },
      text: {
        textAlign: "right",
        paddingTop: 3,
      },
      fullscreenLine: {
        height: "1px",
        width: "100%",
        backgroundColor: "black",
      },
      tableHeadingLine: {
        height: "150px",
        borderRight: "1px solid black",
        paddingTop: "30px",
        fontSize: "10px",
        fontWeight: "600px",
      },

      tabletd: {
        borderRight: "1px solid black", // Right border for the table cell
        padding: 5,                    // Padding inside the cell
        fontSize: "8px",               // Font size for text
        display: "flex",               // Enable flexbox for layout
        flexDirection: "column",          // Default flex direction (not critical here)
        alignItems: "center",          // Vertically center the content
        justifyContent: "center",      // Horizontally center the content
        height: "190px",               // Height of the cell
        width: "55px",                 // Width of the cell
      },

      headerlastText: {
        position: "absolute",
        bottom: "0",
        left: "0",
        right: "0",
      },
      headerFlex: {
        display: "flex",
        flexDirection: "row",
      },
      tdFlex: {
        maxWidth: "100%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: "0",
      },
      bottomText: {
        fontSize: "10px",
        paddingTop: "5",
        textAlign: "left",
      },
      bottomText: {
        fontSize: "10px",
        paddingTop: "5",
        textAlign: "left",
      },
      bottomRightText: {
        fontSize: "12px",
        paddingTop: "5",
        textAlign: "right",
        width: "100%",
      },
      verticalText: {
        transform: 'rotate(-90deg)', 
        textAlign: 'center',
        fontSize: 10,
        color: "blue",
        width:"150px",
        whiteSpace: "nowrap",
      },
      
    });
    const getFormattedDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = today.getFullYear();
    
      return `${day}/${month}/${year}`;
    };

    return(
      <Document>
        <Page orientation="landscape" size="letter" style={styles.page}>
          {arrayData?.map((item, index) => {
            return(

             <>
          <View>
            <Image
              style={{ width: "80px", position: "absolute", maxHeight: "70px" }}
              src="https://png.pngtree.com/template/20200426/ourmid/pngtree-ss-initial-circle-logo-template-vector-image_366767.jpg"
            />
          </View>
          <View style={styles.section}>
            <Text style={{ width: "30%" }}></Text>
            <Text
              style={{
                ...styles.textCenter,
  
                width: "40%",
              }}
            >
            Hindi
            </Text>
            <Text style={{ ...styles.text, width: "30%" }}>Hindi</Text>
            <Text style={{ ...styles.text, width: "30%" }}></Text>
            <Text
              style={{
                paddingTop: 5,    
                alignContent: "center",
                fontSize: "18px",
                fontWeight: "bold",
                width: "40%",
              }}
            >
            Tools and Plant Received Sheets
            </Text>
            <Text style={{ ...styles.text, width: "30%" }}>
              {" "}
              C.P.W.A.-13 (Revised){" "}
            </Text>
            <Text style={{ width: "30%" }}></Text>
            <Text
              style={{
                width: "40%",
                fontSize: "10px",
              }}
            >
            Hindi
            </Text>
            <Text
              style={{ ...styles.textCenter, width: "30%", fontSize: "10px" }}
            ></Text>
            <Text style={{ width: "30%" }}></Text>
            <Text
              style={{
                width: "40%",
                fontSize: "10px",
              }}
            >
            {"(Refered to in paragraph 7.3.4)"}
            </Text>
            <Text style={{ ...styles.text, width: "30%" }}> </Text>{" "}
            <Text
              style={{
                width: "30%",
                fontSize: "10px",
                ...styles.textLeft,
              }}
            >
            Hindi
            </Text>

            <Text
              style={{
                width: "40%",
                fontSize: "10px",
              }}
            >
              Hindi
            </Text>
            <Text
              style={{ ...styles.textCenter, width: "30%", fontSize: "10px" }}
            >
              {" "}
              Hindi{" "}
            </Text>{" "}
            <Text style={{ width: "30%", ...styles.textLeft }}>
              Division......................
            </Text>
            <Text
              style={{
                width: "40%",
              }}
            >
              ORIGINAL/DUPLICATE/REPLICATE{" "}
            </Text>
            <Text style={{ ...styles.textCenter, width: "30%" }}>
              {" "}
              Sub-Division{" "}
            </Text>{" "}
            <Text style={{ width: "30%" }}></Text>
            <Text style={styles.fullscreenLine}></Text>
            <View style={{ ...styles.tableHeadingLine, width: "35px" }}>
              <Text>{"सीरीयल"}</Text>
              <br />
              <Text>{"नम्बर"}</Text>
  
              <br />
              <Text>Serial No </Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                1
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "25px" }}>
              <Text>तारीख</Text>
              <br />
              <Text>Date</Text>
  
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                2
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "55px" }}>
              <Text>इनवॉइस/आर</Text>
              <Text>आर नंबर</Text>
  
              <br />
              <Text>Invoice/</Text>
              <br />
              <Text>R.R.No</Text>
  
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                3
              </Text>
            </View>
            <View
              style={{
                ...styles.tableHeadingLine,
                width: "85px",
  
                paddingTop: "0",
              }}
            >
              <Text>खरीद/आपूर्ति</Text>
              <br />
              <Text>आदेश या इंडेंट</Text>
              <br />
              <Text>Purcahse/Supply</Text>
              <br />
              <Text>Order or Indent</Text>
              <View
                style={{
                  ...styles.headerFlex,
                  borderTop: "1px solid black",
  
                  width: "100%",
                }}
              >
                <View
                  style={{
                    height: "100px",
                    width: "50%",
  
                    borderRight: "1px solid black",
                  }}
                >
                  <Text>संख्या</Text>
                  <br />
                  <Text>No</Text>
                  <br />
                  <Text
                    style={{
                      ...styles.headerlastText,
                    }}
                  >
                    14/A
                  </Text>
                </View>
                <View
                  style={{
                    height: "100px",
                    width: "50%",
                  }}
                >
                  <Text>तारीख</Text>
                  <br />
                  <Text>Date</Text>
                  <br />
                  <Text
                    style={{
                      ...styles.headerlastText,
                    }}
                  >
                    14/B
                  </Text>
                </View>
              </View>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "80px" }}>
              <Text>प्राप्ति का स्रोत</Text>
              <br />
              <Text>Source of Receipt</Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                5
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "80px" }}>
              <Text>लेख का नाम</Text>
              <br />
              <Text>Name of Artical</Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                6
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "50px" }}>
              <Text>मात्रा</Text>
              <br />
              <Text>Quantity</Text>
              <br />
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                7
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "30px" }}>
              <Text>इकाई</Text>
              <br />
              <Text>Unit</Text>
              <br />
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                8 9
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "40px" }}>
              <Text>दर</Text>
              <br />
              <Text>Rate</Text>
              <br />
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                10
              </Text>
            </View>
            <View style={{ ...styles.tableHeadingLine, width: "50px" }}>
              <Text>मात्रा</Text>
              <br />
              <Text>Amount</Text>
              <br />
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                11
              </Text>
            </View>
            <View
              style={{ ...styles.tableHeadingLine, width: "50px", paddingTop: 0 }}
            >
              <Text>आकस्मिक</Text>
              <br />
              <Text>प्रभार</Text>
              <br />
              <Text>Incidental</Text>
              <br />
              <Text>Charges</Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                12
              </Text>
            </View>
            <View
              style={{ ...styles.tableHeadingLine, width: "40px", paddingTop: 0 }}
            >
              <Text>औजार</Text>
              <br />
              <Text>& पौधे</Text>
              <br />
              <Text>खाता बही</Text>
              <br />
              <Text>जिल्द</Text>
              <br />
              <Text>Tools</Text>
              <br />
              <Text>& Plants</Text>
              <br />
              <Text>ledger</Text>
              <br />
              <Text>Folio</Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                13
              </Text>
            </View>
            <View
              style={{ ...styles.tableHeadingLine, width: "70px", paddingTop: 0 }}
            >
              <Text>औजार</Text>
              <br />
              <Text>& पौधे</Text>
              <br />
              <Text>खाता बही</Text>
              <br />
              <Text>जिल्द</Text>
              <br />
              <Text>Reference to</Text>
              <br />
              <Text>Payment Voucher</Text>
              <br />
              <Text>or adjustment</Text>
              <br />
              <Text>of debit</Text>
              <View
                style={{
                  ...styles.headerFlex,
                  borderTop: "1px solid black",
  
                  width: "100%",
                }}
              >
                <View
                  style={{
                    height: "35px",
                    width: "50%",
  
                    borderRight: "1px solid black",
                  }}
                >
                  <Text>संख्या</Text>
                  <br />
                  <Text>No</Text>
                  <br />
                  <Text>14 A</Text>
                </View>
                <View
                  style={{
                    height: "35px",
                    width: "50%",
                  }}
                >
                  <Text>तारीख</Text>
                  <br />
                  <Text>Dated</Text>
                  <br />
                  <Text>14 B</Text>
                </View>
              </View>
            </View>
            <View
              style={{
                ...styles.tableHeadingLine,
                border: "none",
                width: "81px",
                paddingTop: 3,
              }}
            >
              <Text>
                टिप्पणियों में वरिष्ठ अधिकारी द्वारा टेस्ट चेक के डिंग-परिणाम
                शामिल हैं
              </Text>
  
              <br />
              <Text>
                Remarks Include dingResults of Test Check by Superior Officer
              </Text>
              <Text
                style={{
                  ...styles.headerlastText,
                }}
              >
                15
              </Text>
            </View>
            <Text style={styles.fullscreenLine}></Text>

            <View style={{ ...styles.tabletd, width: "35px" }}>
              <Text style={{color:"blue"}} >{index +1}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "25px" }}>
              <Text style={styles.verticalText}>{getFormattedDate()}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "55px" }}>
              <Text style={{...styles.verticalText} }>{item?.bill_ref}</Text>
            </View>

            <View
              style={{
                ...styles.tabletd,
                width: "42.5px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            >
              <Text
                style={{...styles.verticalText, }}
              >
                {item?.bill_ref}
              </Text>             
            </View>

            <View
              style={{
                ...styles.tabletd,
                width: "42.5px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            >
              <Text
                style={{...styles.verticalText, }}
              >
                {moment(item?.purchase_date).format('DD/MM/YYYY')}
              </Text>         
            </View>


            <View style={{ ...styles.tabletd, width: "80px" }}>
              <Text style={{color:"blue"}}>{item?.vendor}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "80px" }}>
              <Text style={{color:"blue"}}>{item?.name}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "50px" }}>
              <Text style={{color:"blue"}}>{item?.quantity}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "30px" }}>
              <Text style={{color:"blue"}} >Nos</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "40px" }}>
              <Text style={{...styles.verticalText,}}>{new Intl.NumberFormat('en-IN').format(item?.unit_price)}</Text>
            </View>
            <View style={{ ...styles.tabletd, width: "50px" }}>
              <Text style={{...styles.verticalText,}}>{item?.unit_price}</Text>
            </View>
            <View
              style={{
                ...styles.tabletd,
                width: "50px",
              }}
            >
              <Text style={{color:"blue"}}>NA</Text>
              </View>
            <View
              style={{
                ...styles.tabletd,
                width: "40px",
                paddingBottom: "0",
              }}
            >
              <Text style={{...styles.verticalText, }}  >{item?.ledge_ref}</Text>
            </View>

            <View
              style={{
                ...styles.tabletd,
                width: "35px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            >
              <Text
                style={{...styles.verticalText, }}
              >
                NA
              </Text>         
            </View>
            <View
              style={{
                ...styles.tabletd,
                width: "35px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            >
              <Text
                style={{...styles.verticalText, }}
              >
                NA
              </Text>         
            </View>
            

            <View
              style={{
                ...styles.tabletd,
                border: "none",
                width: "81px",
              }}
            >
              <Text style={{color:"blue"}} >{item?.remarks}</Text>
            </View>
            <Text style={styles.fullscreenLine}></Text>

            <Text style={{ ...styles.bottomText, width: "100%" }}>
              * Hindi Text
              </Text>
              <Text style={{ ...styles.bottomText }}>
                * The article to be entered in column 6 should be grouped by the
                prescribed sub heads of classificaation vide paragraph 7.3.7.
              </Text>
              <Text style={{ ...styles.bottomText, width: "100%" }}>
                * * Hindi Text
              </Text>
              <Text style={{ ...styles.bottomText }}>
                * * The entries in respect of receipt back of artical lent out or
                sent out (vide paragraph 7.3.3) should be distinguished from others
                quotin refernnce to the orginhal entries in the Tools and Plants in
                Col.15.
              </Text>
              <Text style={{ ...styles.bottomRightText, paddingRight: "40px" }}>
                अनुमंडल कार्यालय
              </Text>
              <Text style={{ ...styles.bottomRightText, paddingRight: "20px" }}>
                Sub Divisional Office
              </Text>
            

          </View>
          </>)
          })}
        </Page>
      
      </Document>
    )

}

export default Form_13;
